<template>
  <div class="app-container">
    <CrudTable entity="FinishType" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'description',
        {
          field: 'finishTypeOption',
          label: 'common.finishType',
          formatter: this.formatfinishTypeOption,
          sortable: false,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('finishtype'),
            valueField: 'code',
            labelField: 'description'
          }
        }
      ]
    };
  },
  methods: {
    generateSummary({ description }) {
      const summary = `${description}`;
      return summary;
    },
    formatfinishTypeOption(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('finishtype').find(item => item.code === cellValue);
      return option && option.description;
    }
  }
};
</script>
